<program-list-item *ngFor="let learnspace of lsList; index as i"
  [learnspace]="learnspace"
  [title]="learnspace.title"
  [description]="learnspace.description"
  [poster]="learnspace.postermedia?.path"
  [tags]="learnspace.properties?.tags"
  [experienceCount]="learnspace.experienceCount"
  [showCollaborators]="true"
  [collaboratorsCount]="getParticipantsCount(learnspace)"
  [clickDeactived]="isArchived(learnspace)"
  [canDelete]="canDelete(learnspace.owner_id)"
  [accessProtected]="!this.canEnter(learnspace)"
  [canNotEnter]="!canEnter(learnspace)"
  [isArchived]="isArchived(learnspace)"
  [showMenu]="isParticipant(learnspace)"
  (enter)="enterLearnspace(learnspace)"
  (showParticipants)="showLsParticipants(learnspace, $event)"
  (update)="updateLearnspace(learnspace)"
  (delete)="deleteLearnspace(learnspace, i)"
  (unsubscribe)="unsubscribeToLearnspace(learnspace, i)"
  (contactSales)="contactSales()"
  [canCreateSpace]="canCreateSpace"
  (duplicate)="duplicateSpace(learnspace)"
></program-list-item>
<div class="loader-overlay" *ngIf="isProcessing">
  <span class="spinner"></span>
</div>
